import { createContext, useContext, useEffect, useState } from 'react'
import api from '../config/api'
import * as auth from '../services/auth'
import { toast } from 'react-toastify'
import React from 'react'
import { useHistory } from 'react-router-dom'

interface LoginProps {
    email: string
    password: string
}

interface AuthContextData {
    signed: boolean
    user: object | null
    scopes: {
        id: number
        description: string
    }[]
    signIn({ email, password }: LoginProps): Promise<void>;
    signOut(): void;
}


const AuthContext = createContext<AuthContextData>({} as AuthContextData)

export const AuthProvider: React.FC = ({ children }) => {

    const [user, setUser] = useState<object | null>(null)
    const [loading, setLoading] = useState(true)
    const [scopes, setScopes] = useState<{
        id: number
        description: string
    }[]>([])



    useEffect(() => {
        async function loadStorageData() {
            //@ts-ignore
            const storagedUser = localStorage.getItem('@sicredi_admin:user')
            const storagedToken = localStorage.getItem('@sicredi_admin:token')
            const storagedScopes = localStorage.getItem('@sicredi_admin:scopes')

            if (storagedToken && storagedUser && storagedScopes) {
                api.defaults.headers.Authorization = `Bearer ${storagedToken}`
                setUser(JSON.parse(storagedUser))
                setScopes(JSON.parse(storagedScopes))
            }

            setLoading(false)
        }
        loadStorageData()
    }, [])

    async function signIn({ password, email }: LoginProps) {
        const response = await auth.signIn({ email, password })
        if (response === null) {
            toast.error('Usuário ou senha incorreto(s)!', {
                position: "top-right",
                autoClose: 3000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: false,
                progress: undefined,
            });
        } else {
            setUser(response.user)
            const responseScope = await getScopes(response.user)
            setScopes(responseScope)

            api.defaults.headers.Authorization = `Bearer ${response.token}`
            localStorage.setItem('@sicredi_admin:user', JSON.stringify(response.user))
            localStorage.setItem('@sicredi_admin:scopes', JSON.stringify(responseScope))
            localStorage.setItem('@sicredi_admin:token', response.token)
        }
        setLoading(false);
    }

    async function getScopes(user: any) {
        const { role_id } = user
        const roleResponse = await api.get(`/roles/${role_id}`)
        const { scopes } = roleResponse.data.role

        return scopes
    }

    async function signOut() {
        setLoading(true);
        setUser(null)
        setScopes([])
        localStorage.removeItem('@sicredi_admin:user')
        localStorage.removeItem('@sicredi_admin:token')
        localStorage.removeItem('@sicredi_admin:scopes')
        setLoading(false);
    }

    if (loading) {
        return (
            <div style={{ display: 'flex', flex: 1, justifyContent: 'center', alignItems: 'center' }}>
                <strong>Carregando</strong>
            </div>
        )
    } else {
        return (
            <AuthContext.Provider value={{ signed: !!user, user, signIn, signOut, scopes }}>
                {children}
            </AuthContext.Provider>
        )
    }
}

export function useAuth(): AuthContextData {
    const context = useContext(AuthContext)
    return context
}

